import React, { useEffect } from 'react';
import * as plausible from '../../services/plausible';
import { createBodyFromMessage, createMailtoLink } from '../../utils/createMailtoLinks';

export default function ErrorPage() {
  const message = '';
  const isUrgent = false;

  const subject = `${isUrgent ? '[!] ' : ''}Newslit Support Request`;

  const mailtoLink = createMailtoLink(
    'help@newslit.co',
    subject,
    createBodyFromMessage(message, true)
  );

  useEffect(() => {
    plausible.trackEvent('500', {
      path: window?.location?.pathname,
    });
  }, []);

  return (
    <>
      <div className="min-h-full pt-16 pb-12 flex flex-col bg-white">
        <main className="grow flex flex-col justify-center max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8">
          {/* TODO: Add Newslit logo */}
          {/*<div className="shrink-0 flex justify-center">*/}
          {/*  <a href="/" className="inline-flex">*/}
          {/*    <span className="sr-only">Newslit News</span>*/}
          {/*    <img*/}
          {/*      className="h-12 w-auto"*/}
          {/*      src="https://tailwindui.com/img/logos/workflow-mark.svg?color=indigo&shade=600"*/}
          {/*      alt=""*/}
          {/*    />*/}
          {/*  </a>*/}
          {/*</div>*/}

          <div className="py-16">
            <div className="text-center">
              <h1 className="mt-2 text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl">
                Uh oh! An error has occurred
              </h1>
              <p className="mt-2 text-base text-gray-500">
                Sorry, we are having troubles loading this page.
              </p>
              <div className="mt-6">
                <a
                  href={mailtoLink}
                  className="text-base font-medium text-secondary hover:text-secondary-dark"
                >
                  Contact us if the issue persists
                </a>
              </div>
            </div>
          </div>
        </main>
        <footer className="shrink-0 max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="flex justify-center space-x-4">
            <a href={mailtoLink} className="text-sm font-medium text-gray-500 hover:text-gray-600">
              Contact Support
            </a>
            <span className="inline-block border-l border-gray-300" aria-hidden="true" />
            <a
              href="https://twitter.com/newslit"
              className="text-sm font-medium text-gray-500 hover:text-gray-600"
            >
              Twitter
            </a>
          </nav>
        </footer>
      </div>
    </>
  );
}
